import React from 'react';
import T from 'prop-types';
import { Descriptions, Skeleton, Tag } from 'antd';

import ErrorAlert from '../../../errorAlert';
import UserPlanTag from '../../../userPlanTag';

import UpdateSubscriptionButton from '../updateSubscriptionButton';
import { Title, StyledCard } from './style';

const SubscriptionCard = ({ currentPeriodEnd, duration, error, errorMessage, isCanceled, isLoading, price }) => {
  const title = (
    <>
      <Title>Current subscription</Title>
    </>
  );

  const content = (
    <Descriptions colon={false} layout="vertical">
      <Descriptions.Item label="Plan">
        <UserPlanTag />
        {isCanceled && <Tag>Canceled</Tag>}
      </Descriptions.Item>
      <Descriptions.Item label="Pricing Information">{`${price}/${duration}`}</Descriptions.Item>
      <Descriptions.Item label={isCanceled ? 'Plan expires' : 'Plan renewal'}>{currentPeriodEnd}</Descriptions.Item>
    </Descriptions>
  );

  return (
    <StyledCard bordered={false} extra={<UpdateSubscriptionButton />} title={title}>
      <ErrorAlert message={errorMessage} visible={error} />
      {isLoading ? <Skeleton active paragraph={{ rows: 2 }} title={false} /> : content}
    </StyledCard>
  );
};

SubscriptionCard.propTypes = {
  currentPeriodEnd: T.string.isRequired,
  duration: T.string.isRequired,
  error: T.bool.isRequired,
  errorMessage: T.string.isRequired,
  isCanceled: T.bool.isRequired,
  isLoading: T.bool.isRequired,
  price: T.string.isRequired,
};

export default SubscriptionCard;
